import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IResponse } from 'src/app/pages/base/interfaces';
import { MaestroModel } from '../maestro.model';
import { EmpresaService } from '../../services/configuracion/empresa.service';


export class Empresa extends MaestroModel {

    public static RECORD_NAME = 'empresas';
    public static CODIGO_REGISTRO = 'empresa';
    public static CODIGO_MODULO = 'configuracion';
    public static NOMBRE_SINGULAR = 'Empresa';
    public static NOMBRE_PLURAL = 'Empresas';


    public static NORMAL = 1;
    public static INVERSIONISTA = 2;
    public static COOPERATIVA = 3;

    public static TIPOS = [
        { valor: 1, nombre: 'Normal' },
        { valor: 2, nombre: 'Inversionista' },
        { valor: 3, nombre: 'Cooperativa' },
    ];

    private _ruc: string;
    private _ciudad: string;
    private _direccion: string;
    private _telefono: string;
    private _correoHostSaliente: string;
    private _correoPuertoSaliente: string;
    private _correoUsuario: string;
    private _correoContrasenha: string;
    private _inversionista: boolean;
    private _tipo: number;
    private _correo: string;
    private _imagen: string;
    private _correoAlias: string;
    private _costoExtracto: number;
    private _costoFlyer: number;
    private _costoWhatsapp: number;
    private _costoSms: number;
    private _costoConsultaExtracto: number;
    private _cantidadEnvioCorreos: number;
    private _intervaloEnvioCorreos: number;
    private _validarCorreo: boolean;
    private _loteSms: number;
    private _loteWhatsapp: number;
    private _loteEmail: number;
    private _intervaloLoteMs: number;
    private _maxRegistrosArchivo: number;
    private _whatsappRemitente: string;
    private _whatsappRemitenteHabilitado: boolean;
    private _wabaId: string;
    private _phoneNumberId: string;
    private _whatsappReactivationTemplateId: number;


    constructor() {
        super();
        this._inversionista = false;
        this._tipo = Empresa.NORMAL;
        this._whatsappRemitenteHabilitado = true;
        this._wabaId = '';
        this._phoneNumberId = '';
    }

    public set ruc( ruc: string ) {
        this._ruc = ruc;
    }
    public get ruc(): string {
        return this._ruc;
    }

    public set ciudad( ciudad: string ) {
        this._ciudad = ciudad;
    }
    public get ciudad(): string {
        return this._ciudad;
    }

    public set tipo( tipo: number ) {
        this._tipo = tipo;
    }
    public get tipo(): number {
        return this._tipo;
    }

    public set direccion( direccion: string ) {
        this._direccion = direccion;
    }
    public get direccion(): string {
        return this._direccion;
    }

    public set telefono( telefono: string ) {
        this._telefono = telefono;
    }
    public get telefono(): string {
        return this._telefono;
    }

    public set correoHostSaliente( correoHostSaliente: string ) {
        this._correoHostSaliente = correoHostSaliente;
    }
    public get correoHostSaliente(): string {
        return this._correoHostSaliente;
    }

    public set correoPuertoSaliente( correoPuertoSaliente: string ) {
        this._correoPuertoSaliente = correoPuertoSaliente;
    }
    public get correoPuertoSaliente(): string {
        return this._correoPuertoSaliente;
    }

    public set correoUsuario( correoUsuario: string ) {
        this._correoUsuario = correoUsuario;
    }
    public get correoUsuario(): string {
        return this._correoUsuario;
    }

    public set correoContrasenha( correoContrasenha: string ) {
        this._correoContrasenha = correoContrasenha;
    }
    public get correoContrasenha(): string {
        return this._correoContrasenha;
    }

    public set inversionista( inversionista: boolean ) {
        this._inversionista = inversionista;
    }
    public get inversionista(): boolean {
        return this._inversionista;
    }

    public set correo( ruc: string ) { this._ruc = ruc };
    public get correo(): string { return this._ruc };

    public set imagen( imagen: string ) { this._imagen = imagen };
    public get imagen(): string { return this._imagen };

    public set correoAlias( correoAlias: string ) { this._correoAlias = correoAlias };
    public get correoAlias(): string { return this._correoAlias };

    public set costoExtracto( costoExtracto: number ) {
        this._costoExtracto = costoExtracto;
    }
    public get costoExtracto(): number {
        return this._costoExtracto;
    }
    public set costoFlyer( costoFlyer: number ) {
        this._costoFlyer = costoFlyer;
    }
    public get costoFlyer(): number {
        return this._costoFlyer;
    }
    public set costoWhatsapp( costoWhatsapp: number ) {
        this._costoWhatsapp = costoWhatsapp;
    }
    public get costoWhatsapp(): number {
        return this._costoWhatsapp;
    }
    public set costoSms( costoSms: number ) {
        this._costoSms = costoSms;
    }
    public get costoSms(): number {
        return this._costoSms;
    }

    public set costoConsultaExtracto( costoConsultaExtracto: number ){
        this._costoConsultaExtracto = costoConsultaExtracto;
    }
    public get costoConsultaExtracto(): number {
        return this._costoConsultaExtracto;
    }

    public set cantidadEnvioCorreos( cantidadEnvioCorreos: number ){
        this._cantidadEnvioCorreos = cantidadEnvioCorreos;
    }
    public get cantidadEnvioCorreos(): number {
        return this._cantidadEnvioCorreos;
    }

    public set intervaloEnvioCorreos( intervaloEnvioCorreos: number ){
        this._intervaloEnvioCorreos = intervaloEnvioCorreos;
    }
    public get intervaloEnvioCorreos(): number {
        return this._intervaloEnvioCorreos;
    }

    public set validarCorreo( validarCorreo: boolean ) { this._validarCorreo = validarCorreo; }
    
    public get validarCorreo(): boolean { return this._validarCorreo; }

    public set loteSms( loteSms: number ) { this._loteSms = loteSms; }
    public get loteSms(): number { return this._loteSms; }

    public set loteWhatsapp( loteWhatsapp: number ) { this._loteWhatsapp = loteWhatsapp; }
    public get loteWhatsapp(): number { return this._loteWhatsapp; }

    public set loteEmail( loteEmail: number ) { this._loteEmail = loteEmail; }
    public get loteEmail(): number { return this._loteEmail; }

    public set intervaloLoteMs( intervaloLoteMs: number ) { this._intervaloLoteMs = intervaloLoteMs; }
    public get intervaloLoteMs(): number { return this._intervaloLoteMs; }

    public set maxRegistrosArchivo( maxRegistrosArchivo: number ) { this._maxRegistrosArchivo = maxRegistrosArchivo; }
    public get maxRegistrosArchivo(): number { return this._maxRegistrosArchivo; }

    public set whatsappRemitente( whatsappRemitente: string ) { this._whatsappRemitente = whatsappRemitente; }
    public get whatsappRemitente(): string { return this._whatsappRemitente; }

    public set whatsappRemitenteHabilitado( whatsappRemitenteHabilitado: boolean ) { this._whatsappRemitenteHabilitado = whatsappRemitenteHabilitado; }
    public get whatsappRemitenteHabilitado(): boolean { return this._whatsappRemitenteHabilitado; }

    public set wabaId( wabaId: string ) { this._wabaId = wabaId; }
    public get wabaId(): string { return this._wabaId; }

    public set phoneNumberId( phoneNumberId: string ) { this._phoneNumberId = phoneNumberId; }
    public get phoneNumberId(): string { return this._phoneNumberId; }

    public set whatsappReactivationTemplateId( whatsappReactivationTemplateId: number ) { this._whatsappReactivationTemplateId = whatsappReactivationTemplateId; }
    public get whatsappReactivationTemplateId(): number { return this._whatsappReactivationTemplateId; }

    public static get columsOnLista(): Record<string, any>[] {
        return [
            { field: 'ruc', label: 'RUC', type: 'text' },
            { field: 'nombre', label: 'Nombre', type: 'text' },
            { field: 'ciudad', label: 'Ciudad', type: 'text' },
            { field: 'direccion', label: 'Direccion', type: 'text' },
            { field: 'telefono', label: 'Telefono', type: 'text' },
        ]
    }

    async cargarDatos( objeto: Record<string, any>) {
        this._ruc = objeto.ruc;
        this._ciudad = objeto.ciudad;
        this._direccion = objeto.direccion;
        this._telefono = objeto.telefono;
        this._correoHostSaliente = objeto.correo_host_saliente;
        this._correoPuertoSaliente = objeto.correo_puerto_saliente;
        this._correoUsuario = objeto.correo_usuario;
        this._correoContrasenha = objeto.correo_contrasenha;
        this._inversionista = objeto.inversionista;
        this._tipo = objeto.tipo;
        this._correo = objeto.correo;
        this._imagen = objeto.imagen;
        this._correoAlias = objeto.correo_alias;
        this._costoExtracto = objeto.costo_extracto;
        this._costoFlyer = objeto.costo_flyer;
        this._costoWhatsapp = objeto.costo_whatsapp;
        this._costoSms = objeto.costo_sms;
        this._costoConsultaExtracto = objeto.costo_consulta_extracto;
        this._cantidadEnvioCorreos = objeto.cantidad_envio_correos;
        this._intervaloEnvioCorreos = objeto.intervalo_envio_correos;
        this._validarCorreo = objeto.validar_correo;
        this._loteSms = objeto.lote_sms;
        this._loteWhatsapp = objeto.lote_whatsapp;
        this._loteEmail = objeto.lote_email;
        this._intervaloLoteMs = objeto.intervalo_lote_ms;
        this._maxRegistrosArchivo = objeto.max_registros_archivo;
        this._whatsappRemitente = objeto.whatsapp_remitente;
        this._whatsappRemitenteHabilitado = objeto.whatsapp_remitente_habilitado !== false;
        this._wabaId = objeto.waba_id;
        this._phoneNumberId = objeto.phone_number_id;
        this._whatsappReactivationTemplateId = objeto.whatsapp_reactivation_template_id;
    }

    async cargarObjeto( objeto: Record<string, any> ) {
        await super.cargarObjeto( objeto );
        await this.cargarDatos( objeto );
    }

    async actualizarDatos( objeto: Record< string, any> ) {
        await super.actualizarDatos( objeto );
        await this.cargarDatos( objeto );
    }

    /**
     * Retorna el formulario a utilizar en las ventanas
     * @returns FormGroup
     */
    async getFormGroup(): Promise<FormGroup> {
        let fg = await super.getFormGroup();
        fg.addControl("ruc", new FormControl(this._ruc, Validators.required));
        fg.addControl("ciudad", new FormControl(this._ciudad));
        fg.addControl("direccion", new FormControl(this._direccion));
        fg.addControl("telefono", new FormControl(this._telefono));
        fg.addControl("correo_host_saliente", new FormControl(this._correoHostSaliente));
        fg.addControl("correo_puerto_saliente", new FormControl(this._correoPuertoSaliente));
        fg.addControl("correo_usuario", new FormControl(this._correoUsuario));
        fg.addControl("correo_contrasenha", new FormControl(this._correoContrasenha));
        fg.addControl("inversionista", new FormControl(this._inversionista));
        fg.addControl("tipo", new FormControl(this._tipo));
        fg.addControl("correo", new FormControl(this._correo));
        fg.addControl("imagen", new FormControl(this._imagen));
        fg.addControl("correo_alias", new FormControl(this._correoAlias));
        fg.addControl("costo_extracto", new FormControl(this._costoExtracto));
        fg.addControl("costo_flyer", new FormControl(this._costoFlyer));
        fg.addControl("costo_whatsapp", new FormControl(this._costoWhatsapp));
        fg.addControl("costo_sms", new FormControl(this._costoSms));
        fg.addControl("costo_consulta_extracto", new FormControl(this._costoConsultaExtracto));
        fg.addControl("cantidad_envio_correos", new FormControl(this._cantidadEnvioCorreos));
        fg.addControl("intervalo_envio_correos", new FormControl(this._intervaloEnvioCorreos));
        fg.addControl("validar_correo", new FormControl(this._validarCorreo ));
        fg.addControl("lote_sms", new FormControl(this._loteSms));
        fg.addControl("lote_whatsapp", new FormControl(this._loteWhatsapp));
        fg.addControl("lote_email", new FormControl(this._loteEmail));
        fg.addControl("intervalo_lote_ms", new FormControl(this._intervaloLoteMs));
        fg.addControl("max_registros_archivo", new FormControl(this._maxRegistrosArchivo));
        // E.164 internacional. Antes estaba restringido a Paraguay (+595):
        // Meta no limita por pais y la apertura es una decision de producto.
        fg.addControl("whatsapp_remitente", new FormControl(this._whatsappRemitente, Validators.pattern(/^\+[1-9]\d{7,14}$/)));
        fg.addControl("whatsapp_remitente_habilitado", new FormControl(this._whatsappRemitenteHabilitado));
        // Identificadores de Meta. Los completa el Embedded Signup, no se escriben
        // a mano: por eso los controles arrancan deshabilitados.
        fg.addControl("waba_id", new FormControl({ value: this._wabaId, disabled: true }));
        fg.addControl("phone_number_id", new FormControl({ value: this._phoneNumberId, disabled: true }));
        fg.addControl("whatsapp_reactivation_template_id", new FormControl(this._whatsappReactivationTemplateId));
        return fg;
    }

    async guardar( service: EmpresaService ): Promise<IResponse> {
        return await service.post( this.serverJson );
    }

    async actualizar( service: EmpresaService  ): Promise<IResponse> {
        return await service.put(this.id, this.serverJson);
    }

    async eliminar( service: EmpresaService ): Promise<IResponse> {
        return await service.delete(this.id);
    }

}
